import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {NgbActiveModal,} from '@ng-bootstrap/ng-bootstrap';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Discount} from '../../../classes/Discount';
import {DiscountType} from '../../../enums/DiscountType';
import {BookingOption} from '../../../enums/BookingOption';

@Component({
  selector: 'app-discount-edit',
  styleUrls: ['./discount-edit.component.scss'],
  templateUrl: './discount-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DiscountEditComponent implements OnInit {

  @Input() discount: Discount;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;

  types: string[];
  bookingOptions: string[];

  public discountForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.types = Object.keys(DiscountType);
    this.bookingOptions = Object.keys(BookingOption);

    if (this.discount) {
      this.discountForm = this.formBuilder.group({
        id: [this.discount.id],
        value: [this.discount.value, Validators.required],
        type: [this.discount.type, Validators.required],
        bookingOption: [this.discount.bookingOption],
      });
    } else {
      this.discountForm = this.formBuilder.group({
        id: [null],
        value: [0, Validators.required],
        type: [DiscountType.PERCENT, Validators.required],
        bookingOption: [null]
      });
    }
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }
}
